import React, { useState } from "react";
import axios from "axios";
import "./Campaigns.css";
import { toast } from "react-toastify";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

function CreateCampaignModal({ onClose, onCreated }) {
  const [name, setName] = useState("");
  const [expiresAt, setExpiresAt] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!name || !expiresAt) return toast.error("Completa todos los campos");

    try {
      setLoading(true);

      await axios.post(`${API}/api/campaigns`, {
        campaignId: `CAM-${Date.now()}`,
        name,
        expiresAt
      });

      onCreated();
      onClose();
    } catch (err) {
      console.error("Error creando campaña", err);
      toast.error("Error creando campaña");
    } finally {
      setLoading(false);
    }
  };

  return (
  <div className="camp-modal-overlay">
    <div className="cam-modal">

      {/* HEADER */}
      <div className="cam-modal-header">
        <h3 className="cam-modal-title">Creación de Campaña</h3>
      </div>
 
      {/* CONTENIDO */}
      <div className="cam-modal-content">

        <div className="cam-form-group">
          <label>Nombre de la campaña</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="cam-form-group">
          <label>Fecha de expiración</label>
          <input
            type="date"
            value={expiresAt}
            onChange={(e) => setExpiresAt(e.target.value)}
          />
        </div>

      </div>

      {/* ACCIONES */}
      <div className="cam-modal-actions-center">
        <button
          className="cam-btn cam-btn-secondary"
          onClick={onClose}
        >
          Cancelar
        </button>

        <button
          className="cam-btn-primary"
          onClick={submit}
          disabled={loading}
        >
          {loading ? "Creando..." : "Crear campaña"}
        </button>
      </div>

    </div>
  </div>
);


}

export default CreateCampaignModal;
